import React from 'react';

export interface GetVariableDomainsPaneProps {}

export default function GetVariableDomainsPane(props: GetVariableDomainsPaneProps): JSX.Element {
  return (
    <div>
      <h3>DNA Variable Domains</h3>
      <p>How do you want to bring in your DNA variable domain sequences?</p>
      <p>This will include a project/folder selector with a search interface.</p>
      <h3>AA Variable Domains</h3>
      <p>Configure parameters for translating DNA domains to AA domains.</p>
    </div>
  );
}
